module.exports = __webpack_public_path__ + "media/images/payments/okpay-dark-17eece3c07dbe5bd4ed04e93afd48820.svg";